import { useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { useBankConnectionsQuery, useDisconnectBankMutation } from '../../../api/gql';
import { ConfirmationDialog } from '../../../components/dialogs/ConfirmationDialog';
import { notify } from '../../../utils/notification';
import { useSafeNavigation } from '../../../hooks/useSafeNavigation';

export const DisconnectBankPage = () => {
  const { bankConnectionId } = useParams();
  const { t } = useTranslation('bank-connection');
  const { safeNavigate } = useSafeNavigation();
  const queryClient = useQueryClient();
  const { mutate: disconnectBank } = useDisconnectBankMutation({
    onSuccess: () => {
      notify.positive({ message: t('bankDisconnection.mutation.success') });
      queryClient.refetchQueries({
        queryKey: useBankConnectionsQuery.getKey(),
      });
      safeNavigate('/bank-connection');
    },
    onError: (e) => {
      console.error(e);
      notify.negative({ message: t('bankDisconnection.mutation.error') });
      safeNavigate('/bank-connection');
    },
  });

  const onClose = (confirmed: boolean) => {
    if (confirmed) {
      onConfirm();
    }

    safeNavigate('/bank-connection');
  };

  const onConfirm = () => {
    if (!bankConnectionId) {
      return;
    }
    disconnectBank({
      id: bankConnectionId,
    });
  };

  return (
    <ConfirmationDialog
      onClose={onClose}
      title={t('bankDisconnection.title')}
      description={t('bankDisconnection.description')}
      open={true}
    />
  );
};
